import { Select } from 'antd'
import React, { useEffect } from 'react'
import Loader from '../pages/pages/loader'
import { toast } from 'react-toastify'
import { useGetDomainsCategoriesQuery } from '../redux/apis/domainsManagement/category/dMDomainsCategoryApiSlice'

const DomainCategoryDropdown = ({
  onChange,
  onBlur,
  value,
  className = '',
}) => {
  const { data, isLoading, error } = useGetDomainsCategoriesQuery({
    page: '*',
    category_status:true,
    fields: ['id','domain_category'].join(','),
  })

useEffect(()=>{
        if ( !error && !isLoading) {
            return
        }
        toast.error(error)
    },[error, isLoading])

  return (
    <div className=' mb-3'>
      <Loader isLoading={isLoading} />
      <label className="form-label">Domain Category</label>
      <br />
      <Select
        name='domainCategory'
        className={className}
        showSearch
        style={{
          width: '100%'
        }}
        optionFilterProp='label'
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? '')
            .toLowerCase()
            .localeCompare((optionB?.label ?? '').toLowerCase())
        }
        defaultValue={value}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        loading={isLoading}
        options={data?.data?.results?.map(x => {
          return { label: x.domain_category, value: x.id }
        })}
      />
    </div>
  )
}

export default DomainCategoryDropdown
